import { ShieldCheck } from "lucide-react";
import { useLang } from "@/i18n";
import { IMG } from "@/data/media";
import { PageHero } from "@/components/PageHero";
import { DonateCards } from "@/components/DonateCards";
import { FadeUp } from "@/components/motion";
import { L } from "@/components/L";

export default function Donate() {
  const { t } = useLang();
  const d = t.donate;
  return (
    <>
      <PageHero eyebrow={d.eyebrow} lines={d.titleLines} intro={d.intro} image={IMG.baby} imageAlt={t.gallery.captions.baby} corner="bl" accent="var(--coral)" />
      <section className="pb-20 sm:pb-28" data-testid="donate-section">
        <div className="wrap">
          <DonateCards full />
          <FadeUp className="mt-10 grid gap-6 lg:grid-cols-12 items-center">
            <p className="lg:col-span-8 flex gap-3 items-start text-[var(--ink-soft)] bg-white rounded-2xl p-5 shadow-[0_0_0_1px_var(--line)]" data-testid="donate-no-online-note">
              <ShieldCheck size={20} className="shrink-0 mt-0.5 text-[var(--green-deep)]" /> {d.noOnline}
            </p>
            <div className="lg:col-span-4 lg:text-right">
              <L to="contact" search={`?subject=${encodeURIComponent(d.ctaInfo)}`} className="btn btn-primary" data-testid="donate-request-info-btn">{d.ctaInfo}</L>
            </div>
          </FadeUp>
        </div>
      </section>
    </>
  );
}
